import React from "react";
import "./LeaderPersonalization.css";
import Print_media_Name_holder from "../Print_media_Name_holder/Print_media_Name_holder";

function LeaderPersonalization() {
  return (
    <>
      <div className="main_LeaderPersonalization_holder">
        <Print_media_Name_holder />
        <section className="LeaderPersonalization">
          <div className="custom_container">
            <div className=" heading_holder">
              <h3>Printout Media </h3>
              <h6>Your Go-To Leader in Personalization!</h6>
            </div>
            <div className="text_holder">
              <p>
                At Printout Media, We Specialize In Bringing Your Ideas To Life
                With High-Quality, Customizable Products Tailored Just For You.
                From Business Essentials Like Customized Stationery, Brochures,
                And Business Cards To Personalized Gifts, Apparel, And
                Promotional Items, We Are Your Trusted Partner For All Things
                Creative And Unique. Driven By Innovation And Excellence, We
                Focus On Delivering Products That Stand Out, Helping You Make A
                Lasting Impression. Whether You’re An Entrepreneur Building A
                Brand Or An Individual Looking To Create Something Special,
                Printout Media Is Here To Turn Your Vision Into Reality.
              </p>
            </div>

            <div className="LeaderPersonalization_bottom_text">
              <p>Printout Media – Because Personalization Is Our Passion!</p>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default LeaderPersonalization;
